module.exports = __webpack_public_path__ + "static/img/indexAbanner.da93e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/indexAbanner.png
// module id = xEoH
// module chunks = 0